import { useNavigate } from 'react-router-dom';
import { forwardRef, useCallback, useMemo } from 'react';
import { Tabs, TabList, Tab, HStack } from '@cdl/heartbeat-react';
import { NavigationTab } from '../../ecg/types/application-path.types';
import { Portal } from '../../../shared/components/Portal';
import {
  getApplicationPath,
  setDefaultPathIndex,
} from '../../ecg/utils/application-path.utils';
import { useHeaderRef } from '../../ecg/hooks/useHeaderRef';
import { NavbarActions } from './Navigation/NavbarActions';

const CLUSTERING_TABS: NavigationTab[] = [
  { label: 'Clean', path: 'clean' },
  { label: 'Merge', path: 'merge' },
];
interface Props {
  ecgId: string;
}

export const ClusteringHeader = forwardRef<HTMLDivElement, Props>(
  ({ ecgId }, ref) => {
    const navigate = useNavigate();
    const headerRef = useHeaderRef();
    const path = getApplicationPath(window.location);
    const navigatePath = useCallback(
      (tabIndex: number) => {
        const path = CLUSTERING_TABS[tabIndex]?.path || 'clean';
        navigate(`/${ecgId}/clustering/${path}`);
      },
      [navigate, ecgId],
    );
    const defaultTabIndex = useMemo(
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      () => setDefaultPathIndex(CLUSTERING_TABS, path!),
      [path],
    );

    if (path == null) {
      return null;
    }

    return (
      <Portal to={headerRef}>
        <HStack flex={1} justifyContent='space-between'>
          <Tabs onChange={navigatePath} index={defaultTabIndex}>
            <TabList mb='-s' border='0'>
              {CLUSTERING_TABS.map((tab) => (
                <Tab key={tab.path}>{tab.label}</Tab>
              ))}
            </TabList>
          </Tabs>
          <NavbarActions ecgId={ecgId} ref={ref} />
        </HStack>
      </Portal>
    );
  },
);
